
import React from "react";
import { AlertTriangle, RefreshCw, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";

interface InconsistentStateProps {
  onRetry: () => void;
  onReauth: () => void;
}

const InconsistentState: React.FC<InconsistentStateProps> = ({ onRetry, onReauth }) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <div className="bg-yellow-500/10 p-6 rounded-full mb-6">
        <AlertTriangle className="h-12 w-12 text-yellow-400" />
      </div>
      
      <h3 className="text-xl font-semibold text-white mb-2">
        Estado Inconsistente Detectado
      </h3>
      
      <p className="text-white/60 mb-6 max-w-md">
        Você está autenticado, mas o feed não está carregando corretamente. 
        Isso pode ser um problema temporário de sincronização.
      </p>
      
      <div className="flex flex-col sm:flex-row gap-3">
        <Button
          onClick={onRetry}
          variant="outline"
          className="bg-white/10 border-white/20 hover:bg-white/20 text-white"
        >
          <RefreshCw className="h-4 w-4 mr-2" />
          Tentar Novamente
        </Button>
        
        <Button
          onClick={onReauth}
          variant="outline"
          className="bg-red-500/10 border-red-400/20 hover:bg-red-500/20 text-red-400"
        >
          <LogOut className="h-4 w-4 mr-2" />
          Fazer Login Novamente
        </Button>
      </div>
      
      <p className="text-white/40 text-sm mt-4">
        Se o problema persistir, tente fazer login novamente
      </p>
    </div>
  );
};

export default InconsistentState;
